import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/utils/seo";

export default function NotFound() {
  const location = useLocation();
  useSeo({
    title: "页面不存在 - 黑料",
    description: "你访问的页面不存在，返回黑料首页浏览最新的娱乐八卦与揭秘资讯。",
    keywords: "黑料,页面不存在,404",
  });

  return (
    <SiteLayout>
      <div className="relative px-4 md:px-6 py-24 md:py-32 flex flex-col items-center justify-center text-center overflow-hidden">
        <span className="absolute text-[140px] md:text-[220px] font-heading font-extrabold text-background-100 select-none pointer-events-none z-0 leading-none">
          404
        </span>
        <div className="relative z-10 flex flex-col items-center">
          <span className="w-16 h-16 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center mb-5">
            <i className="ri-ghost-2-line text-3xl" />
          </span>
          <h1 className="font-heading font-extrabold text-2xl md:text-3xl mb-3">
            这条线索断了
          </h1>
          <p className="text-foreground-600 max-w-md mb-2">
            你要找的页面不存在或已被移除，不妨回到首页，看看今天正在热传的黑料。
          </p>
          <p className="text-xs text-foreground-400 font-mono mb-7">{location.pathname}</p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md border border-background-300 text-sm hover:border-primary-300 hover:text-primary-600 transition cursor-pointer whitespace-nowrap"
            >
              <i className="ri-search-line" />
              去站内搜索
            </Link>
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}